import { useEffect, useState } from 'react';

import { extractProgramCodeFromMobiusData } from '@core/services/mobius';

export default function useProgramCode(programId?: number | null) {
  const [code, setCode] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    const fetchProgramCode = async (id: number) => {
      try {
        const c = await extractProgramCodeFromMobiusData(id);
        console.log('[useProgramCode] programId=%s, result=%s', id, c);
        if (mounted) setCode(c);
      } catch {
        if (mounted) setCode(null);
      }
    };

    if (programId) {
      fetchProgramCode(programId);
    } else {
      setCode(null);
    }

    return () => {
      mounted = false;
    };
  }, [programId]);

  return code;
}
